module.exports = __webpack_public_path__ + "img/lgactive.8620be69.png";